export class SharepointDocumentContentRequest {
    siteURL: string;
    siteUniqueID: string;
    documentLibraryName: string;
    documentFolderPath: string;
    fileNamesWithPath: string[];
}